import React from "react";
import { Link } from "react-router-dom";

const SaleItem = ({ sale }) => {
  const getPaymentStatusClass = (status) => {
    return status === "Part Payment" ? "text-b9565e" : "text-56b98f";
  };

  return (
    <li>
      <Link to={`/sales/${sale.id}/details`}>
        <div>
          <h6>Sale #{sale.sale_id}</h6>
          <span className="text-uppercase">
            {sale?.date} {sale?.time}
          </span>
        </div>
        <span className={`status ${getPaymentStatusClass(sale.payment_status)}`}>
          {sale.payment_status}
        </span>
      </Link>
    </li>
  );
};

export default SaleItem;